export enum ResponseStatus {
  SUCCESS = 'Success',
  ERROR = 'Error',
  NOT_FOUND = 'NotFound',
}
